import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'redux/store';
import { toastActions } from 'redux/toasts';

export const useToastContainer = () => {
  const { toasts } = useSelector((store: Store) => store.toasts);
  const dispatch = useDispatch();

  const closeToast = (toastId: string) => {
    dispatch(toastActions.removeToast(toastId));
  };

  return {
    toasts,
    closeToast,
  };
};
